import PhoneDisplayLink from './PhoneDisplayLink';

export { ICON_ORIENTATION, LAST_FOUR_DEFAULT_HOME_PAGE } from './constants';

export default PhoneDisplayLink;
